/**
 * Money at the presentation edge. CLAUDE.md 3.1; plan 8, decision 7.
 *
 * The API sends every cents value as a STRING, because a JSON number would become an IEEE-754
 * double in `JSON.parse` before any code saw it. The browser formats that string and does
 * nothing else with it: no sums, no comparisons, no `Number()`. This is the one place `BigInt`
 * is called on a cents value in `apps/web`, so the rule has one line to check.
 */

import { formatCents } from '@sixgen/core';

/** `"185000"` → `"$1,850.00"`; `"-1250"` → `"-$12.50"`. Throws on anything that is not an integer. */
export function formatMoney(cents: string): string {
  return formatCents(BigInt(cents));
}
